import axios from '../../helpers/axios-setup';

export const downloadApplicationProfile = (labRequestId: number) => axios.get(`/lab-requests/${labRequestId}/profile`);
